<template>
    <div id="fileList">
      <CRow class="mb-3 search-panel">
        <CCol xs="12" sm="6" md="6" lg="6" xl="4">
          <BaseInput :options="titleInput.options" :data="titleInput.data" :listener="titleInput.listener" />
        </CCol>
        <CCol xs="12" sm="6" md="6" lg="6" xl="4">
          <BaseInput :options="keyRequestInput.options" :data="keyRequestInput.data" :listener="keyRequestInput.listener" />
        </CCol>
        <CCol xs="12" sm="6" md="6" lg="6" xl="4">
          <BaseSelect :options="statusInput.options" :data="statusInput.data" />
        </CCol>
        <CCol xs="12" sm="6" md="6" lg="6" xl="4">
          <BaseInput :options="createUserNameInput.options" :data="createUserNameInput.data" :listener="createUserNameInput.listener" />
        </CCol>
        <CCol xs="12" sm="6" md="6" lg="6" xl="4">
          <BaseInput :options="jsonRequestInput.options" :data="jsonRequestInput.data" :listener="jsonRequestInput.listener" />
        </CCol>
        <CCol xs="12" sm="6" md="6" lg="6" xl="4">
          <BaseInput :options="jsonResponseInput.options" :data="jsonResponseInput.data" :listener="jsonResponseInput.listener" />
        </CCol>
        <CCol>
          <div class="form-group">
            <label style="color: white"></label>
            <div style="margin-top: 10px">
              <CButton style="float: right; margin-left: 5px; margin-top: 1px;" color="primary"
                v-c-tooltip.hover="'Tải lại'" class="btn-action-primary" @click="loadDataMainTable(true)">
                <i class="fa fa-refresh"></i>&nbsp;Tải lại
              </CButton>
            </div>
          </div>
        </CCol>
      </CRow>
      <CRow class="row-2">
  
      </CRow>
      <CCard class="content-fade-in mt-3p5">
        <CCardBody>
          <BaseTable :options="mainTable.options" :slots="mainTable.slots" :dataSource="mainTable.dataSource"
            ref="mainTable">
            <template #index="{ index }">
              <td>{{ $refs.mainTable.getTotalElementByPage + index }}</td>
            </template>
  
            <template #createDate="{ item }">
              <td v-if="item.createDate != null">
                {{ $helper.formatDateDDMMYYYYHHMM(item.createDate) }}
              </td>
              <td v-else></td>
            </template>
            <template #status="{ item }">
              <td>
                <span v-if="item.status === 1" class="text-success">Thành công</span>
                <span v-else-if="item.status === 0" class="text-danger">Thất bại</span>
                <span v-else>-</span>
              </td>
            </template>
            <template #jsonRequest="{ item }">
              <td>
                <CButton color="info" size="sm" variant="outline" @click="openJsonModal('Request', item.jsonRequest)">
                  Xem
                </CButton>
              </td>
            </template>
            <template #jsonResponse="{ item }">
              <td>
                <CButton color="info" size="sm" variant="outline" @click="openJsonModal('Response', item.jsonResponse)">
                  Xem
                </CButton>
              </td>
            </template>
          </BaseTable>
        </CCardBody>
      </CCard>

      <CModal :title="jsonViewer.title" :show.sync="jsonViewer.isShow" size="lg" :closeOnBackdrop="false">
        <pre class="json-viewer">{{ jsonViewer.content }}</pre>
        <template v-slot:footer>
          <button type="button" class="btn btn-secondary" @click="jsonViewer.isShow = false">
            Đóng
          </button>
        </template>
      </CModal>
  
      <ModalConfirm :actionTypeMapping="actionData.actionTypeMapping" ref="actionModal"></ModalConfirm>
  
      <BaseFormLoading :loading="loading.value"></BaseFormLoading>
  
  
    </div>
  </template>
  
  <script>
  import BaseTable from "@/views/base/BaseDataTable";
  import ModalConfirm from "@/views/base/BaseModalConfirm";
  import BaseInput from "@/views/base/BaseInput";
  import BaseSelect from "@/views/base/BaseSelect2";
  import BaseFormLoading from "@/views/base/BaseFormLoading";
  import BaseModal from "@/views/base/BaseModal";
  import BaseSwitch from "@/views/base/BaseSwitch";
  
  export default {
    name: "LogSyncHtttnList",
    components: {
      BaseFormLoading,
      BaseTable,
      ModalConfirm,
      BaseInput,
      BaseSelect,
      BaseModal,
      BaseSwitch
    },
    notifications: {
      showSuccessMsg: {
        type: "success",
        title: "Success",
      },
      showErrorMsg: {
        type: "error",
        title: "Error",
      },
      showWarningMsg: {
        type: "warn",
        title: "warn",
      },
    },
    data() {
      let that = this;
      let actionTypeMapping = new Map();
      return {
        labelIcon: {
          labelOn: '\u2713',
          labelOff: '\u2715'
        },
        isShowModal: false,
        isSelectedAllDevices: false,
        loading: {
          value: false,
        },
        jsonViewer: {
          isShow: false,
          title: '',
          content: ''
        },
        actionData: {
          actionTypeMapping: actionTypeMapping,
          model: {
            selectedAll: false,
            configId: null,
            configName: null
          }
        },
        titleInput: {
          options: {
            placeholder: "Dịch vụ",
            label: "Dịch",
          },
          data: {
            name: "name",
            model: "",
            updateTrigger: function () {
              return that.$refs.mainTable;
            },
          },
        },
        keyRequestInput: {
          options: {
            placeholder: "Key request",
            label: "Key request",
          },
          data: {
            name: "keyRequest",
            model: "",
            updateTrigger: function () {
              return that.$refs.mainTable;
            },
          },
        },
        statusInput: {
          options: {
            filter: false,
            label: "Trạng thái",
            keyField: "key",
            valueField: "value",
            selectAllText: "Tất cả",
          },
          data: {
            name: "status",
            items: [
              { key: "1", value: "Thành công" },
              { key: "0", value: "Thất bại" }
            ],
            model: "",
            updateTrigger: function () {
              return that.$refs.mainTable;
            },
          },
        },
        createUserNameInput: {
          options: {
            placeholder: "Tài khoản",
            label: "Tài khoản",
          },
          data: {
            name: "createUserName",
            model: "",
            updateTrigger: function () {
              return that.$refs.mainTable;
            },
          },
        },
        jsonRequestInput: {
          options: {
            placeholder: "Request",
            label: "Request",
          },
          data: {
            name: "jsonRequest",
            model: "",
            updateTrigger: function () {
              return that.$refs.mainTable;
            },
          },
        },
        jsonResponseInput: {
          options: {
            placeholder: "Response",
            label: "Response",
          },
          data: {
            name: "jsonResponse",
            model: "",
            updateTrigger: function () {
              return that.$refs.mainTable;
            },
          },
        },
        mainTable: {
          options: {
            fields: [
              { key: "index", label: "STT", sorter: false, filter: false },
              { key: "createDate", label: "Ngày tạo", _style: "max-width:5%; width:5%" },
              { key: "name", label: "Dịch vụ" },
              { key: "keyRequest", label: "Key request" },
              { key: "status", label: "Trạng thái" },
              { key: "createUserName", label: "Tài khoản" },
              { key: "jsonRequest", label: "Request" },
              { key: "jsonResponse", label: "Response" },
            ],
            slots: [
              "index", "createDate", "status", "jsonRequest", "jsonResponse"
            ],
            pageSize: 20,
            sorter: true,
            columnFilter: false,
            itemsPerPageSelect: { label: ' ', values: [15, 20, 30, 50, 100], external: true },
            tableFilter: { label: 'Bộ lọc:', placeholder: 'Nhập ký tự cần tìm kiếm', external: false, lazy: true },
          },
          dataSource: {
            url: "/log-sync-htttn/getPages",
            dataSubmit: function () {
              var params = that.$helper.setupDataSubmit(that.$data);
              return params;
            },
            response: function (dataResponse) {
              if (dataResponse && dataResponse.data) {
                let rows = null;
                if (dataResponse.data.list && Array.isArray(dataResponse.data.list.content)) {
                  rows = dataResponse.data.list.content;
                } else if (dataResponse.data.dataContent && Array.isArray(dataResponse.data.dataContent.content)) {
                  rows = dataResponse.data.dataContent.content;
                }
                if (rows) {
                  rows.forEach(item => that.applyStatusRowClass(item));
                }
              }
              return dataResponse.data;
            },
          },
        },
      };
    },
    methods: {
      loadDataMainTable: function (isUpdateFilter) {
        this.$refs.mainTable.loadData(true, isUpdateFilter);
      },
      openJsonModal(type, raw) {
        this.jsonViewer.title = type;
        this.jsonViewer.content = this.prettyJson(raw);
        this.jsonViewer.isShow = true;
      },
      prettyJson(raw) {
        if (raw == null || raw === '') {
          return '{}';
        }
        try {
          if (typeof raw === 'string') {
            return JSON.stringify(JSON.parse(raw), null, 2);
          }
          return JSON.stringify(raw, null, 2);
        } catch (e) {
          return String(raw);
        }
      },
      applyStatusRowClass(item) {
        if (!item) return;
        if (item.status === 1 || item.status === "1") {
          item._classes = "status-success-row";
          return;
        }
        if (item.status === 0 || item.status === "0") {
          item._classes = "status-failed-row";
          return;
        }
        item._classes = "";
      },

    },
    created: function () {
    },
    mounted() {
    },
    watch: {
    },
    computed: {},
  };
  </script>
  <style>
  .row-2 .form-group {
    margin-top: 0 !important;
  }
  .json-viewer {
    max-height: 65vh;
    overflow: auto;
    background: #f8f9fa;
    border: 1px solid #dee2e6;
    border-radius: 4px;
    padding: 12px;
    white-space: pre-wrap;
    word-break: break-word;
    margin-bottom: 0;
  }
  .status-success-row td {
    background-color: #e8f5e9 !important;
    color: #1b5e20;
  }
  .status-failed-row td {
    background-color: #ffebee !important;
    color: #b71c1c;
  }
  </style>